module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VGSEAFOOD2-437277685fdd3c8b41c4a8029b282c52.png";